import {Decadence} from "../Decadence";

export interface IWinRatioConfig {
    ratio:number;
    name:string;
    duration:number;
    winLevel:number;
    bigWinLevel:number;
    sound?:string;
}

export interface BIG_WIN_THRESHOLD {
    numberOfReels:number,
    requiredWinRatio:number
};


export class DecadenceWinConfig {
    public static BASE_THRESHOLDS:BIG_WIN_THRESHOLD[] = [
        {numberOfReels: 1, requiredWinRatio: 15},
        {numberOfReels: 2, requiredWinRatio: 40},
        {numberOfReels: 4, requiredWinRatio: 60},
    ];
    public static BONUS_THRESHOLDS:BIG_WIN_THRESHOLD[] = [
        {numberOfReels: 1, requiredWinRatio: 50},
        {numberOfReels: 2, requiredWinRatio: 100},
        {numberOfReels: 4, requiredWinRatio: 200},
    ];
    public static SUPER_BONUS_THRESHOLDS:BIG_WIN_THRESHOLD[] = [
        {numberOfReels: 1, requiredWinRatio: 100},
        {numberOfReels: 2, requiredWinRatio: 200},
        {numberOfReels: 4, requiredWinRatio: 400},
    ];

    public static WIN_RATIOS:IWinRatioConfig[] = [
        {
            ratio : 0,
            name : "Tiny Win",
            duration : 0,
            winLevel : 0,
            bigWinLevel : -1,
        },
        {
            ratio : 1,
            name : "Small Win",
            duration : 0.5,
            winLevel : 1,
            bigWinLevel : -1,
            sound: "winSmall"
        },
        {
            ratio : 3,
            name : "Medium Win",
            duration : 0.9,
            winLevel : 2,
            bigWinLevel : -1,
            sound: "winMedium"
        },
        {
            ratio : 5,
            name : "Large Win",
            duration : 2,
            winLevel : 3,
            bigWinLevel : -1,
            sound: "winLarge"
        },
        {
            ratio : 15,
            name : "Big Win 1",
            duration : 3.86,
            winLevel : 3,
            bigWinLevel : 1,
            sound: "winLarge",
        },
        {
            ratio : 25,
            name : "Big Win 2",
            duration : 4.68,
            winLevel : 3,
            bigWinLevel : 2,
            sound: "winLarge",
        },
        {
            ratio : 50,
            name : "Big Win 3",
            duration : 4.73,
            winLevel : 3,
            bigWinLevel : 3,
            sound: "winLarge",
        },
        {
            ratio : 100,
            name : "Big Win 4",
            duration : 7,
            winLevel : 3,
            bigWinLevel : 4,
            sound: "winLarge",
        },
        {
            ratio : 500,
            name : "Big Win 5",
            duration : 4,
            winLevel : 3,
            bigWinLevel : 5,
            sound: "winLarge",
        }
    ];

    public static getWinConfig(winRatio:number):IWinRatioConfig {
        let currentConf = DecadenceWinConfig.WIN_RATIOS[0];
        for(let i:number=1; i < DecadenceWinConfig.WIN_RATIOS.length; i++) {
            if(winRatio < DecadenceWinConfig.WIN_RATIOS[i].ratio) break;

            currentConf = DecadenceWinConfig.WIN_RATIOS[i];
        }
        return currentConf;
    }

    public static bigWinThresholdReached(winRatio:number, numberOfReels:number):boolean {
        const activeFeature = Decadence.apiPlugin.betFeatureController.getActiveBetFeature();
        const isFeatureBuy = Decadence.model.data.wasFeatureBuy;
        if(!isFeatureBuy) {
            const threshold = DecadenceWinConfig.BASE_THRESHOLDS.find(t => t.numberOfReels == numberOfReels);
            return threshold!.requiredWinRatio <= winRatio;
        } else {
            if(activeFeature?.name.includes("SUPER")) {
                const threshold = DecadenceWinConfig.SUPER_BONUS_THRESHOLDS.find(t => t.numberOfReels == numberOfReels);
                return threshold!.requiredWinRatio <= winRatio;
            } else {
                const threshold = DecadenceWinConfig.BONUS_THRESHOLDS.find(t => t.numberOfReels == numberOfReels);
                return threshold!.requiredWinRatio <= winRatio;
            }
        }
    }

    public static getBigWinLevels(winRatio:number):IWinRatioConfig[] {
        return DecadenceWinConfig.WIN_RATIOS.filter(conf => conf.bigWinLevel > 0 && conf.ratio < winRatio);
    }
}

